import { capitalize } from 'lodash';
import { UrlQueryOperatorKey } from '/@/modules/core/app/enums/UrlQueryOperatorKey';
import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';

export class UrlQueryOperator extends Enum {
  static GREATER_THAN = {
    key: UrlQueryOperatorKey.GREATER_THAN,
    get value() {
      return Lang.t('core.greater-than');
    }
  };

  static LESS_THAN = {
    key: UrlQueryOperatorKey.LESS_THAN,
    get value() {
      return Lang.t('core.less-than');
    }
  };

  static EQUAL_TO = {
    key: UrlQueryOperatorKey.EQUAL_TO,
    get value() {
      return Lang.t('estate.is');
    }
  };

  static NOT_EQUAL_TO = {
    key: UrlQueryOperatorKey.NOT_EQUAL_TO,
    get value() {
      return Lang.t('estate.is-not');
    }
  };

  static GREATER_THAN_EQUAL_TO = {
    key: UrlQueryOperatorKey.GREATER_THAN_EQUAL_TO,
    get value() {
      return Lang.t('core.greater-equal');
    }
  };

  static LESS_THAN_EQUAL_TO = {
    key: UrlQueryOperatorKey.LESS_THAN_EQUAL_TO,
    get value() {
      return Lang.t('core.less-equal');
    }
  };

  static BETWEEN = {
    key: UrlQueryOperatorKey.BETWEEN,
    get value() {
      return Lang.t('core.between');
    }
  };

  static NOT_BETWEEN = {
    key: UrlQueryOperatorKey.NOT_BETWEEN,
    get value() {
      return Lang.t('core.not-between');
    }
  };

  static IN = {
    key: UrlQueryOperatorKey.IN,
    get value() {
      return capitalize(Lang.t('core.in'));
    }
  };

  static NOT_IN = {
    key: UrlQueryOperatorKey.NOT_IN,
    get value() {
      return capitalize(Lang.t('core.not-in'));
    }
  };

  static ENCRYPTED = {
    key: UrlQueryOperatorKey.ENCRYPTED,
    get value() {
      return Lang.t('core.encrypted');
    }
  };

  static CONTAINS = {
    key: UrlQueryOperatorKey.CONTAINS,
    get value() {
      return capitalize(Lang.t('core.contains'));
    }
  };

  static isOperatorMultiple(operator) {
    return [
      UrlQueryOperator.IN.key,
      UrlQueryOperator.NOT_IN.key,
      UrlQueryOperator.BETWEEN.key,
      UrlQueryOperator.NOT_BETWEEN.key
    ].includes(operator);
  }

  /**
   * @param {any} value
   * @returns {string}
   */
  static toEncrypted(value) {
    return `${UrlQueryOperator.ENCRYPTED.key}|${value}`;
  }

  /**
   * @param {string} operator
   * @param {null|string|array} value
   * @param {null|string|array} secondValue
   * @return {string}
   */
  static buildQueryParam(operator, value, secondValue = null) {
    return `${operator}|${UrlQueryOperator.getFilterValue(operator, value, secondValue)}`;
  }

  /**
   * @param {string} operator
   * @param {?string} value
   * @param {?string} secondValue
   * @return {string}
   */
  static getFilterValue(operator, value, secondValue = null) {
    switch (operator) {
      case UrlQueryOperator.LESS_THAN.key:
      case UrlQueryOperator.LESS_THAN_EQUAL_TO.key:
      case UrlQueryOperator.GREATER_THAN.key:
      case UrlQueryOperator.GREATER_THAN_EQUAL_TO.key:
      case UrlQueryOperator.EQUAL_TO.key:
      case UrlQueryOperator.NOT_EQUAL_TO.key:
      case UrlQueryOperator.CONTAINS.key:
        return value;
      case UrlQueryOperator.IN.key:
      case UrlQueryOperator.NOT_IN.key:
        return value.join(',');
      case UrlQueryOperator.BETWEEN.key:
      case UrlQueryOperator.NOT_BETWEEN.key:
        return `${value},${secondValue}`;
      default:
        throw Error(Lang.t('core.operator-not-supported'));
    }
  }
}
